import { render, staticRenderFns } from "./groupBlack.vue?vue&type=template&id=2209589b&scoped=true"
import script from "./groupBlack.vue?vue&type=script&lang=js"
export * from "./groupBlack.vue?vue&type=script&lang=js"
import style0 from "./groupBlack.vue?vue&type=style&index=0&id=2209589b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2209589b",
  null
  
)

export default component.exports